const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || ""
const PRACTICES_URL = import.meta.env.VITE_PRACTICES_URL || ""
const USERS_URL = import.meta.env.VITE_USERS_URL || ""
const TEMPLATES_URL = import.meta.env.VITE_TEMPLATES_URL || ""
const PLANNING_URL = import.meta.env.VITE_PLANNING_URL || ""

if (import.meta.env.PROD && (!AUTH0_DOMAIN || !PRACTICES_URL || !USERS_URL)) {
  console.error("[config] Critical environment variables missing. Check VITE_AUTH0_DOMAIN, VITE_PRACTICES_URL, VITE_USERS_URL.")
}

export const API_URLS = {
  oauth: AUTH0_DOMAIN,
  planning: PLANNING_URL,
  practices: PRACTICES_URL,
  templates: TEMPLATES_URL,
  users: USERS_URL,
}

export const CLIENT_ID: string = import.meta.env.VITE_CLIENT_ID || ""
export const BASE_URL: string = import.meta.env.VITE_BASE_URL || ""
export const REDIRECT_URI: string = import.meta.env.VITE_REDIRECT_URI || ""
// The two front ends find each other through these; empty means the switch is off
export const BETA_URL: string = import.meta.env.VITE_BETA_URL || ""
export const OLD_APP_URL: string = import.meta.env.VITE_OLD_APP_URL || ""
export const HELP_LINK: string = import.meta.env.VITE_HELP_LINK || "mailto:docketmedical@bleuchaud.com"
export const DISABLE_FOR_CURRENT_RELEASE: string = import.meta.env.VITE_DISABLE_FOR_CURRENT_RELEASE || ""

export const isFeatureFlagEnabled = DISABLE_FOR_CURRENT_RELEASE === "false"
